import { selector } from 'lib/selectors';
import * as ACL from 'domain/restriction';

// Single availability gate for the document-categorization UI (type tabs, Inbox sub-type
// chips, reclassify). Every surface consults this selector (design D5). Available to the
// Bookkeeper role.
//
// "Bookkeeper" == the accountant role family (plain / limited / restricted / read-only).
// `ACL.IS_ACCOUNT` is a policy over all four accountant rights, and the base
// `IS_ACCOUNT` right is granted to every accountant regardless of modificator — so
// `isGranted(ACL.IS_ACCOUNT)` matches the whole family. This holds as long as
// limited/restricted/readonly stay role *modificators* on top of `role === accountant`
// (see `myRestriction` in domain/restriction) rather than distinct role values.
//
// There is deliberately NO feature flag here — beta and stable are separated by deployment
// promotion (DA-19783); do not reintroduce one. Reclassify surfaces carry their own
// `isAccount` ACL, so this selector gates only the read/filter layer.
export const documentCategorizationAllowedSelector = selector<unknown, boolean>(
  ACL.isGranted,
  (isGranted: (policy: unknown) => boolean): boolean => isGranted(ACL.IS_ACCOUNT),
);
